/* eslint-disable react/jsx-key */
import React, { useContext } from "react";
import BackArrow from "../../../assets/images/Icons/backArrow.svg";
import DataTable from "../../../components/DataTableComponent/DataTable";
import Button from "../../../components/ButtonComponent/Button";
import AddContacts from "../../../components/AddContactsComponent/AddContacts";
import { Container } from "react-bootstrap";
import "./contacts.css";
import { ContactsContext } from "../ContactsView";
import TopBar from "../../../components/TopBarComponent/Topbar";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import { Spinner } from "react-bootstrap";
const ContactsPage = ({ textContants }) => {
  const contactsHeader = [
    { title: textContants.name, prop: "EmployeeName" },
    { title: textContants.designation, prop: "Category" },
    { title: textContants.contactNo, prop: "ContactNo" },
  ];
  const {
    goBack,
    show,
    setShow,
    contactsFile,
    setContactsFile,
    contactsFileRequired,
    setContactsFileRequired,
    contactsFilelabel,
    setContactsFilelabel,
    contactsList,
    contactsShowAlert,
    setContactsShowAlert,
    contactsAlertMessage,
    contactsErrorAlertSubmit,
    submitContactsList,

    addContactsPermission,
    handleAlertSubmit,
    logout,

    statusCode,
    spinnerStatus
  } = useContext(ContactsContext);

  return (
    <div className="contacts">
         {spinnerStatus && (
        <div className="spinner-overlay-report">
          <Spinner size="xl" className="custom-spinner-report" />
        </div>)}
      <TopBar />
      <AlertBox
        show={contactsShowAlert}
        setShow={setContactsShowAlert}
        alertMessage={contactsAlertMessage}
        handleSubmit={() => {
          contactsErrorAlertSubmit();
        }}
      />
      <AddContacts
        show={show}
        setShow={setShow}
        contactsFile={contactsFile}
        setContactsFile={setContactsFile}
        contactsFileRequired={contactsFileRequired}
        setContactsFileRequired={setContactsFileRequired}
        contactsFilelabel={contactsFilelabel}
        setContactsFilelabel={setContactsFilelabel}
        submitData={submitContactsList}
      />
      <Container>
        <div className="heading-row my-3">
          <div className="title-box">
            <img
              onClick={() => goBack()}
              className="back-arrow"
              src={BackArrow}
              alt="Back Arrow"
              width={22}
            />
            <p className="title-name">{textContants.pageTitle}</p>
          </div>
          {addContactsPermission && (
            <Button
              onClick={() => setShow(true)}
              text={textContants.addContacts}
            />
          )}
        </div>
        <DataTable
          tableData={contactsList}
          header={contactsHeader}
          isPagination={false}
        />
      </Container>
      {contactsShowAlert && (
        <AlertBox
          show={contactsShowAlert}
          setShow={setContactsShowAlert}
          alertMessage={contactsAlertMessage}
          handleSubmit={
            statusCode == 401 ? () => logout() : () => handleAlertSubmit()
          }
        />
      )}
    </div>
  );
};
export default ContactsPage;
